export function TeamTasksFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/team-tasks-filled.svg'"></ng-include>`
    }
}